import React from "react";

interface SliderProps {
  id: string;
  label?: string;
  value: number;
  min: number;
  max: number;
  step?: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  extra?: string;
  showError?: boolean;
}

const Slider: React.FC<SliderProps> = ({
  id,
  label,
  value,
  min,
  max,
  step = 1,
  onChange,
  disabled = false,
  extra = "",
  showError = false,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseFloat(e.target.value) || 0;
    onChange(newValue);
  };

  const percentage = max > min ? ((value - min) / (max - min)) * 100 : 0;

  return (
    <div className={`${extra}`}>
      {label && (
        <label
          htmlFor={id}
          className="ml-0 mb-2 text-sm font-bold text-navy-700 dark:text-white"
        >
          {label}
        </label>
      )}
      <div className="space-y-2">
        <div className="flex items-center gap-4">
          <div className="flex-1 relative">
            <input
              type="range"
              id={id}
              min={min}
              max={max}
              step={step}
              value={value}
              onChange={handleChange}
              disabled={disabled}
              className="w-full h-2 bg-white dark:bg-navy-800 rounded-lg appearance-none cursor-pointer accent-brand-500 border border-gray-200 dark:border-gray-700"
              style={{
                background: `linear-gradient(to right, #3b82f6 0%, #3b82f6 ${percentage}%, #ffffff ${percentage}%, #ffffff 100%)`,
              }}
            />
            <style>{`
              #${id}::-webkit-slider-thumb {
                appearance: none;
                width: 20px;
                height: 20px;
                border-radius: 50%;
                background: #3b82f6;
                cursor: pointer;
                border: 2px solid white;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
              }
              #${id}::-moz-range-thumb {
                width: 20px;
                height: 20px;
                border-radius: 50%;
                background: #3b82f6;
                cursor: pointer;
                border: 2px solid white;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
              }
              #${id}:disabled {
                opacity: 0.5;
                cursor: not-allowed;
              }
              #${id}:disabled::-webkit-slider-thumb {
                cursor: not-allowed;
              }
              #${id}:disabled::-moz-range-thumb {
                cursor: not-allowed;
              }
            `}</style>
          </div>
          <div className="min-w-[70px] text-right">
            <span className={`text-lg font-semibold ${
              showError 
                ? "text-red-600 dark:text-red-400" 
                : "text-navy-700 dark:text-white"
            }`}>
              {value % 1 === 0 ? value.toFixed(0) : value.toFixed(1)}%
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Slider;
